import { useEffect, useState } from 'react';

import { CompactSchoolLogo } from 'applications/GSP/features/CompactSchoolLogo';
import { SchoolLogo } from 'applications/GSP/features/SchoolLogo';
import { SCHOOL_LOGO_MAX_HEIGHT } from 'applications/GSP/layouts/MainLayout/components/Sidebar/constants';
import { LogoLink } from 'applications/GSP/shared/components/LogoLink';

import { SchoolLogoWrapper } from './components/SchoolLogoWrapper';

import type { SidebarAnimatedComponentsState } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';
import type { FC } from 'react';

export const SchoolSection: FC<SidebarAnimatedComponentsState> = ({
  opened,
}) => {
  const [showFullLogo, setShowFullLogo] = useState(opened);

  useEffect(() => {
    setShowFullLogo(!!opened);
  }, [opened]);

  return (
    <SchoolLogoWrapper opened={opened}>
      <LogoLink sx={{ minHeight: SCHOOL_LOGO_MAX_HEIGHT }}>
        {showFullLogo ? <SchoolLogo /> : <CompactSchoolLogo />}
      </LogoLink>
    </SchoolLogoWrapper>
  );
};
